<script>

import passwordValidation from '../mixins/passwordValidation'
import trans from '../mixins/trans'

export default {
    mixins: [
        passwordValidation,
        trans
    ],

    props: {
        'fieldName': String,
        'locale': String,

    },

    data() {
        return {
            error_messages: [],
            is_valid: false,
            password_confirmation: '',
            password_unequal_message: '',
        }
    },

    methods: {
        checkValidity() {
            if (this.error_messages.length) {
                return false;
            }

            if (this.password_confirmation === $('#password').val()) {
                this.password_unequal_message = '';
                $('#password_confirmation').removeClass('is-invalid');
                return true;
            }

            this.password_unequal_message = this.__('New password and password confirmation are not equal.');
            $('#password_confirmation').addClass('is-invalid');
            return false
        }
    },

    computed: {
        isValid() {
            return this.checkValidity();
        }
    },

    mounted() {
        let self = this;

        $('#password').on('input', function () {
            self.error_messages = self.checkPasswordValidity($("#password").val());
            if (self.error_messages.length) {
                $('#password').addClass('is-invalid');
            } else {
                $('#password').removeClass('is-invalid');
            }
        });
    },

}
</script>
